import React, { useState, useEffect, useRef } from 'react';
import { Info } from 'lucide-react';
import './CardInfoTooltip.css';

const CardInfoTooltip = ({ content, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <span ref={tooltipRef} style={{ position: 'absolute', top: '12px', right: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', boxShadow: 'none', outline: 'none', padding: 0, margin: 0, zIndex: 10 }}>
      <span 
        role="button"
        tabIndex="0"
        style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', 
            width: '22px', height: '22px', padding: 0, margin: 0, 
            border: 'none', borderRadius: '50%', cursor: 'pointer', 
            background: isOpen ? 'rgba(79, 70, 229, 0.35)' : 'rgba(79, 70, 229, 0.15)', 
            color: isOpen ? '#fff' : 'rgba(139, 132, 252, 0.9)', 
            outline: 'none', boxShadow: 'none', transition: 'background 0.2s' 
        }}
        onClick={(e) => { 
            e.preventDefault();
            e.stopPropagation(); 
            setIsOpen(!isOpen); 
        }}
        onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(!isOpen);
            }
        }}
        title={title ? `Info about ${title}` : 'Information'}
      >
        <Info size={14} style={{ background: 'transparent', border: 'none', boxShadow: 'none', outline: 'none' }} />
      </span>
      
      {isOpen && (
        <span className="card-info-popup" onClick={(e) => e.stopPropagation()}>
          {content}
        </span>
      )}
    </span>
  );
};

export default CardInfoTooltip;
